import 'core-js';
import 'regenerator-runtime/runtime';

//[IE11] SVG spriteの表示
import svg4everybody from 'svg4everybody';
svg4everybody();

//[IE11] objectfitの使用
import objectFitImages from 'object-fit-images';
document.addEventListener('DOMContentLoaded', function() {
  objectFitImages();
})

//bodyclass
const isIPad = /iPad|Macintosh/i.test(navigator.userAgent)
&& 'ontouchend' in document
if(isIPad){
  document.querySelector('.l-wrapper').classList.add('is-ipad');
}

//base
import './iosBodyChange.js';
import './anchor.js';
import './gnav.js';
import './flatHeight.js';
import './fixedLayoutScroll.js';
import './topSellSlide.js';
import './articleImageSlide.js';
import './contactform7.js';

